/**
 * The one place a subscription date becomes words. `"2026-03-12T00:00:00Z"` → `"12 Mar 2026"`.
 *
 * Day-first, like the Backtesting history rows (`"27 Jun, 08:01 AM"`) and the date-range trigger —
 * this app does not use US month-first ordering anywhere else, and a billing date is exactly the
 * place an ambiguous `03/12` would be read wrong by half the audience.
 *
 * Time of day is deliberately dropped. Stripe ends a period at a precise instant, but "Pro ends 12
 * Mar 2026, 14:07" invites the wrong question ("what happens at 14:08?") where the honest answer is
 * "that whole day is yours".
 *
 * Returns `null` — never a fallback string — for a null/absent/unparseable value, so a caller must
 * decide what an unknown date means for its own copy rather than rendering "Invalid Date" at a user
 * who has just clicked cancel. The BE nulls `renewsAt`/`endsAt` for every state where they'd be
 * meaningless (the free tier's 2099 sentinel never reaches the wire), so `null` here is routine, not
 * an error.
 */
export function formatPlanDate(iso: string | null | undefined): string | null {
  if (iso == null || iso === '') return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}
